import h from "../services/h";
import errorMessageFilter from "../filters/errorMessageFilter";
import constants from "../constants";

export default {
  methods: {
    handleRequestError(error) {
      this.notify("Lỗi", errorMessageFilter(error), "error", 3000);
      return true;
    },

    buildErrorMessage_(error) {
      return errorMessageFilter(error);
    },

    unknownErrorMessage() {
      return "Lỗi không xác định";
    },

    buildErrorMessages(error) {
      if (error.response && error.response.data) {
        let status = error.response.data.status;
        switch (status) {
          case constants.HTTP_STATUS.FORBIDDEN:
            let errorMessage = errorMessageFilter({
              errorCode: "error.default.403" || error.response.data.message
            });
            this.notify("Lỗi", errorMessage, "error", 2000);
            break;
          default:
            let error_ = error.response.data;
            if (error_.message === "BusinessErrorException") {
              return h.collect(error_.errors, item => this.buildErrorMessage_(item) || this.unknownErrorMessage());
            } else {
              return [this.unknownErrorMessage()];
            }
        }
      }
      return [];
    },

    commonHandleRequestError(error) {
      let errorMessages = this.buildErrorMessages(error);
      h.each(errorMessages, errorMessage => this.notify("Lỗi", errorMessage, "error", 2000));
      return error;
    },

    getMessageError(error) {
      if (!error.response) {
        this.notify("Lỗi", this.unknownErrorMessage(), "error", 2000);
      } else {
        h.each(error.response.data, (item) => {
          if (!this.handleRequestError(item)) {
            this.notify("Lỗi", this.unknownErrorMessage(), "error", 2000);
          }
        });
      }
      return error;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/handleRequestErrorMixin.js